import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const [activeTab, setActiveTab] = useState("1");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white pl-2 pt-2 pb-2 pr-2 w-1/2 rounded-md"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal">
          <h2 className="text-center font-bold text-lg">Menu Details</h2>

          {/* Tab Content */}
          <div className="p-4 max-h-96">
            {activeTab === "1" && (
              <div className="flow-root rounded-lg border border-gray-100 py-3 shadow-sm">
                <dl className="-my-3 divide-y divide-gray-100 text-sm">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900">Parent Name</dt>
                    <dd className="text-gray-700 sm:col-span-2 pl-20">
                      {result?.id_parent}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900">id_sub_parent</dt>
                    <dd className="text-gray-700 sm:col-span-2 pl-20">
                      {result?.id_sub_parent}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900">name</dt>
                    <dd className="text-gray-700 sm:col-span-2 pl-20">
                      {result?.name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900">position</dt>
                    <dd className="text-gray-700 sm:col-span-2 pl-20">
                      {result?.position}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900">is_active</dt>
                    <dd className="text-gray-700 sm:col-span-2 pl-20">
                      {result?.is_active}
                    </dd>
                  </div>
                </dl>
              </div>
            )}

            {isModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-white p-4 rounded-lg max-w-md w-full relative">
                  <button
                    onClick={closeZoomModal}
                    className="viewModelBoxCloseBtn"
                  >
                    <IoIosClose />
                  </button>

                  <img
                    src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                    alt="Selected Company Logo"
                    className="w-full h-auto rounded-lg"
                  />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
